// // Changes made on 29th August to address size filter issue.. mostly working uncomment during maintainance 

// import React, { ChangeEvent, useEffect, useState } from "react";
// import ProductCard from "./ProductCard/ProductCard";
// import FilterSection from "./FilterSection";
// import {
//   Box,
//   Divider,
//   FormControl,
//   IconButton,
//   InputLabel,
//   MenuItem,
//   Pagination,
//   Select,
//   SelectChangeEvent,
//   useMediaQuery,
//   useTheme,
// } from "@mui/material";

// import FilterAltIcon from "@mui/icons-material/FilterAlt";
// import { useParams, useSearchParams } from "react-router-dom";
// import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import { getAllProducts } from "../../../Redux Toolkit/Customer/ProductSlice";

// export const images = [
//   "https://manyavar.scene7.com/is/image/manyavar/I02_ma3053_06-10-2022-09-23:650x900",
//   "https://manyavar.scene7.com/is/image/manyavar/I03_ma3057_06-10-2022-09-24:650x900",
//   "https://manyavar.scene7.com/is/image/manyavar/I04_ma3061_06-10-2022-09-26:650x900",
//   "https://manyavar.scene7.com/is/image/manyavar/I01_ma3055_06-10-2022-09-23:650x900",
// ];

// const Products = () => {
//   const [sort, setSort] = React.useState("");
//   const theme = useTheme();
//   const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
//   const [showFilter, setShowFilter] = useState(false);
//   const { categoryId } = useParams();
//   const dispatch = useAppDispatch();
//   const { products } = useAppSelector((store) => store);
//   const [searchParams, setSearchParams] = useSearchParams();
//   const [page, setPage] = useState(1)


//   const handleSortProduct = (event: SelectChangeEvent) => {
//     setSort(event.target.value as string);
//   };

//   const handleShowFilter = () => {
//     setShowFilter((prev) => !prev);
//     console.log("showFilter   ", showFilter);
//   };

//   const handlePageChange = (value: any) => {
//     setPage(value)
//     console.log("page nummmberr ", value);
//   };

//   useEffect(() => {
//     const [minPrice, maxPrice] = searchParams.get("price")?.split("-") || [];
//     const newFilters = {
//       size: searchParams.get("size") || "",
//       color: searchParams.get("color") || "",
//       minPrice: minPrice ? Number(minPrice) : undefined,
//       maxPrice: maxPrice ? Number(maxPrice) : undefined,
//       pageNumber: page - 1,
//       minDiscount: searchParams.get("discount")
//         ? Number(searchParams.get("discount"))
//         : undefined,
//     };

//     dispatch(getAllProducts({ category: categoryId, sort, ...newFilters }));
//   }, [searchParams, categoryId, sort, page]);


//   // console.log(" store ", products)
//   return (
//     <div className="-z-10 mt-10">
//       <div className="">

//         <h1 className="text-3xl text-center font-bold text-gray-700 pb-5 px-9 uppercase space-x-2">
//           {categoryId?.split("_").map((item) => (
//             <span>{item}</span>
//           ))}
//         </h1>
//       </div>
//       <div className="lg:flex">
//         <section className="hidden lg:block  w-[20%] ">
//           <FilterSection />
//         </section>
//         <div className="w-full lg:w-[80%] space-y-5">
//           <div className="flex justify-between items-center px-9 h-[40px]">
//             <div className="relative w-[50%]">
//               {!isLarge && (
//                 <IconButton onClick={handleShowFilter}>
//                   <FilterAltIcon />
//                 </IconButton>
//               )}
//               {showFilter && !isLarge && (
//                 <Box sx={{ zIndex: 3 }} className="absolute top-[60px]">
//                   <FilterSection />
//                 </Box>
//               )}
//             </div>
//             <FormControl size="small" sx={{ width: "200px" }}>
//               <InputLabel id="sort">Sort</InputLabel>
//               <Select
//                 labelId="sort"
//                 id="sort"
//                 value={sort}
//                 label="Sort"
//                 onChange={handleSortProduct}
//               >
//                 <MenuItem value={"price_low"}>Price : Low - High</MenuItem>
//                 <MenuItem value={"price_high"}>Price : High - Low</MenuItem>
//               </Select>
//             </FormControl>
//           </div>
//           <Divider />

//           {products.products?.length > 0 ? (
//             <section className="grid sm:grid-cols-2   md:grid-cols-3 lg:grid-cols-4 gap-y-5 px-5 justify-center">

//               {products.products.map((item: any, index: number) => (
//                 <div key={index * 9} className={`relative ${!item.in_stock ? 'grayscale pointer-events-none' : ''}`}
//                 >
//                   <ProductCard item={item} />
//                   {!item.in_stock && (
//                     <div className="absolute top-0 left-0 w-full h-full bg-white bg-opacity-40 flex items-center justify-center rounded">
//                     </div>
//                   )}
//                 </div>
//               ))}

//             </section>
//           ) : (
//             <section className="items-center flex flex-col gap-5 justify-center h-[67vh] border">
//               <img
//                 className="w-80"
//                 src="https://cdn.pixabay.com/photo/2022/05/28/10/45/oops-7227010_960_720.png"
//                 alt=""
//               />
//               <h1 className="font-bold text-xl text-center flex items-center gap-2">
//                 Product Not Found For{" "}
//                 <p className="text-primary-color flex gap-2 uppercase">
//                   {" "}
//                   {categoryId?.split("_").map((item) => (
//                     <span>{item}</span>
//                   ))}{" "}
//                 </p>{" "}
//               </h1>
//             </section>
//           )}
//           <div className="flex justify-center pt-10">
//             <Pagination
//               page={page}
//               onChange={(e, value) => handlePageChange(value)}
//               color="primary"
//               count={products?.totalPages}
//               shape="rounded"
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Products;


// import React, { useEffect, useState } from "react";
// import { Box, Button, Drawer, useMediaQuery, useTheme } from "@mui/material";
// import FilterSection from "./FilterSection";
// import ProductCard from "./ProductCard/ProductCard";
// import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import { useParams, useSearchParams } from "react-router-dom";
// import { getAllProducts } from "../../../Redux Toolkit/Customer/ProductSlice";
// import TuneIcon from "@mui/icons-material/Tune";

// const Products = () => {
//   const theme = useTheme();
//   const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
//   const dispatch = useAppDispatch();
//   const { products } = useAppSelector((store) => store);
//   const { categoryId } = useParams();
//   const [searchParams] = useSearchParams();

//   const [mobileFilterOpen, setMobileFilterOpen] = useState(false);

//   const toggleMobileFilter = (open: boolean) => () => {
//     setMobileFilterOpen(open);
//   };

//   useEffect(() => {
//     const brand = searchParams.get("brand");
//     const color = searchParams.get("color");
//     const discount = searchParams.get("discount");
//     const sort = searchParams.get("sort");
//     const page = searchParams.get("page");
//     const minPrice = searchParams.get("minPrice");
//     const maxPrice = searchParams.get("maxPrice");

//     const newFilters: any = {};

//     if (brand) newFilters.brand = brand;
//     if (color) newFilters.color = color;
//     if (discount) newFilters.minDiscount = Number(discount);
//     if (sort) newFilters.sort = sort;
//     if (page) newFilters.pageNumber = Number(page);
//     if (minPrice) newFilters.minPrice = Number(minPrice);
//     if (maxPrice) newFilters.maxPrice = Number(maxPrice);

//     dispatch(
//       getAllProducts({
//         category: categoryId,
//         ...newFilters,
//       })
//     );
//   }, [categoryId, searchParams, dispatch]);

//   return (
//     <div className="px-3 sm:px-4 md:px-6 lg:px-8 xl:px-10 py-4 md:py-6">
//       <div className="flex gap-6">
//         {isLarge && (
//           <div className="w-[280px] shrink-0">
//             <div className="sticky top-24 rounded-[18px] border border-slate-200 bg-white p-5 shadow-sm">
//               <FilterSection />
//             </div>
//           </div>
//         )}

//         <div className="min-w-0 flex-1">
//           {!isLarge && (
//             <div className="mb-4 flex justify-end">
//               <Button
//                 variant="outlined"
//                 startIcon={<TuneIcon />}
//                 onClick={toggleMobileFilter(true)}
//                 sx={{
//                   borderColor: "#cbd5e1",
//                   color: "#111827",
//                   textTransform: "none",
//                   borderRadius: "10px",
//                   fontWeight: 600,
//                 }}
//               >
//                 Filters
//               </Button>
//             </div>
//           )}

//           <Drawer
//             anchor="left"
//             open={mobileFilterOpen}
//             onClose={toggleMobileFilter(false)}
//           >
//             <div className="w-[290px] p-5">
//               <FilterSection />
//             </div>
//           </Drawer>

//           {products.products?.length ? (
//   <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-4 md:gap-5">
//     {products.products.map((item: any, index: number) => (
//       <ProductCard key={item.id || index} item={item} />
//     ))}
//   </div>
// ) : (
//   <Box className="flex items-center justify-center min-h-[300px] text-slate-500 text-lg">
//     No products found
//   </Box>
// )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Products;

// import React, { useEffect, useMemo, useState } from "react";
// import {
//   Box,
//   Button,
//   Drawer,
//   Typography,
//   useMediaQuery,
//   useTheme,
// } from "@mui/material";
// import TuneIcon from "@mui/icons-material/Tune";
// import { useParams, useSearchParams } from "react-router-dom";
// import FilterSection from "./FilterSection";
// // import ProductCard from "../../components/ProductCard/ProductCard";
// import ProductCard from "./ProductCard/ProductCard";
// import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import { getAllProducts } from "../../../Redux Toolkit/Customer/ProductSlice";

// const formatCategoryTitle = (categoryId?: string) => {
//   if (!categoryId) return "Products";

//   return categoryId
//     .replace(/[-_]+/g, " ")
//     .replace(/\b\w/g, (char) => char.toUpperCase());
// };

// const Products = () => {
//   const theme = useTheme();
//   const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
//   const dispatch = useAppDispatch();
//   const { products } = useAppSelector((store) => store);
//   const { categoryId } = useParams();
//   const [searchParams, setSearchParams] = useSearchParams();

//   const [mobileFilterOpen, setMobileFilterOpen] = useState(false);

//   const toggleMobileFilter = (open: boolean) => () => {
//     setMobileFilterOpen(open);
//   };

//   const categoryTitle = useMemo(
//     () => formatCategoryTitle(categoryId),
//     [categoryId]
//   );

//   const clearAllFilters = () => {
//     setSearchParams({});
//   };

//   useEffect(() => {
//     const brand = searchParams.get("brand");
//     const color = searchParams.get("color");
//     const discount = searchParams.get("discount");
//     const sort = searchParams.get("sort");
//     const page = searchParams.get("page");
//     const minPrice = searchParams.get("minPrice");
//     const maxPrice = searchParams.get("maxPrice");

//     const newFilters: any = {};

//     if (brand) newFilters.brand = brand;
//     if (color) newFilters.color = color;
//     if (discount) newFilters.minDiscount = Number(discount);
//     if (sort) newFilters.sort = sort;
//     if (page) newFilters.pageNumber = Number(page);
//     if (minPrice) newFilters.minPrice = Number(minPrice);
//     if (maxPrice) newFilters.maxPrice = Number(maxPrice);

//     dispatch(
//       getAllProducts({
//         category: categoryId,
//         ...newFilters,
//       })
//     );
//   }, [categoryId, searchParams, dispatch]);

//   return (
//     <div className="px-3 sm:px-4 md:px-6 lg:px-8 xl:px-10 py-4 md:py-6">
//       <div className="mb-5 flex items-center justify-between gap-4">
//         <Typography
//           variant="h5"
//           sx={{
//             fontWeight: 700,
//             color: "#111827",
//             fontSize: { xs: "1.25rem", md: "1.6rem" },
//           }}
//         >
//           {categoryTitle}
//         </Typography>

//         <div className="flex items-center gap-2">
//           {!isLarge && (
//             <Button
//               variant="outlined"
//               startIcon={<TuneIcon />}
//               onClick={toggleMobileFilter(true)}
//               sx={{
//                 borderColor: "#cbd5e1",
//                 color: "#111827",
//                 textTransform: "none",
//                 borderRadius: "10px",
//                 fontWeight: 600,
//               }}
//             >
//               Filter
//             </Button>
//           )}

//           <Button
//             variant="text"
//             onClick={clearAllFilters}
//             sx={{
//               textTransform: "none",
//               color: "#061126",
//               fontWeight: 600,
//             }}
//           >
//             Clear All
//           </Button>
//         </div>
//       </div>

//       <div className="flex gap-6">
//         {isLarge && (
//           <div className="w-[280px] shrink-0">
//             <div className="sticky top-24 rounded-[18px] border border-slate-200 bg-white p-5 shadow-sm">
//               <FilterSection />
//             </div>
//           </div>
//         )}

//         <div className="min-w-0 flex-1">
//           <Drawer
//             anchor="left"
//             open={mobileFilterOpen}
//             onClose={toggleMobileFilter(false)}
//           >
//             <div className="w-[290px] p-5">
//               <FilterSection />
//             </div>
//           </Drawer>

//           {products.products?.length ? (
//             <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-4 md:gap-5">
//               {products.products.map((item: any, index: number) => (
//                 <ProductCard key={item.id || index} item={item} />
//               ))}
//             </div>
//           ) : (
//             <Box className="flex items-center justify-center min-h-[60vh] text-slate-500 text-lg">
//               No products found
//             </Box>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Products;


// For modern website

// import React, { useEffect, useState } from "react";
// import ProductCard from "./ProductCard/ProductCard";
// import FilterSection from "./FilterSection";
// import {
//   Box,
//   Divider,
//   FormControl,
//   IconButton,
//   InputLabel,
//   MenuItem,
//   Pagination,
//   Select,
//   SelectChangeEvent,
//   useMediaQuery,
//   useTheme,
//   Drawer,
// } from "@mui/material";
// import FilterAltIcon from "@mui/icons-material/FilterAlt";
// import { useParams, useSearchParams } from "react-router-dom";
// import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import { getAllProducts } from "../../../Redux Toolkit/Customer/ProductSlice";

// export const images = [
//   "https://manyavar.scene7.com/is/image/manyavar/I02_ma3053_06-10-2022-09-23:650x900",
//   "https://manyavar.scene7.com/is/image/manyavar/I03_ma3057_06-10-2022-09-24:650x900",
//   "https://manyavar.scene7.com/is/image/manyavar/I04_ma3061_06-10-2022-09-26:650x900",
//   "https://manyavar.scene7.com/is/image/manyavar/I01_ma3055_06-10-2022-09-23:650x900",
// ];

// const Products = () => {
//   const theme = useTheme();
//   const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
//   const [showFilter, setShowFilter] = useState(false);
//   const { categoryId } = useParams();
//   const dispatch = useAppDispatch();
//   const { products } = useAppSelector((store) => store);
//   const [searchParams, setSearchParams] = useSearchParams();

//   const currentSort = searchParams.get("sort") || "";
//   const currentPage = Number(searchParams.get("page") || "1");

//   const handleSortProduct = (event: SelectChangeEvent) => {
//     const value = event.target.value as string;
//     const params = new URLSearchParams(searchParams);

//     if (value) {
//       params.set("sort", value);
//     } else {
//       params.delete("sort");
//     }

//     params.set("page", "1");
//     setSearchParams(params);
//   };

//   const handleShowFilter = () => {
//     setShowFilter((prev) => !prev);
//   };

//   const handlePageChange = (_event: React.ChangeEvent<unknown>, value: number) => {
//     const params = new URLSearchParams(searchParams);
//     params.set("page", String(value));
//     setSearchParams(params);
//   };

//   useEffect(() => {
//     const newFilters: any = {
//       size: searchParams.get("size") || "",
//       color: searchParams.get("color") || "",
//       pageNumber: currentPage - 1,
//       minDiscount: searchParams.get("discount")
//         ? Number(searchParams.get("discount"))
//         : undefined,
//       minPrice: searchParams.get("minPrice")
//         ? Number(searchParams.get("minPrice"))
//         : undefined,
//       maxPrice: searchParams.get("maxPrice")
//         ? Number(searchParams.get("maxPrice"))
//         : undefined,
//     };

//     dispatch(
//       getAllProducts({
//         category: categoryId,
//         sort: currentSort || undefined,
//         ...newFilters,
//       })
//     );
//   }, [searchParams, categoryId, currentSort, currentPage, dispatch]);

//   return (
//     <div className="-z-10 mt-10">
//       <div>
//         <h1 className="text-3xl text-center font-bold text-gray-700 pb-5 px-9 uppercase space-x-2">
//           {categoryId?.split("_").map((item) => (
//             <span key={item}>{item}</span>
//           ))}
//         </h1>
//       </div>

//       <div className="lg:flex">
//         {/* Desktop Filter */}
//         <section className="hidden lg:block w-[20%]">
//           <FilterSection />
//         </section>

//         {/* Product Area */}
//         <div className="w-full lg:w-[80%] space-y-5">
//           <div className="flex justify-between items-center px-9 h-[40px]">
//             <div className="relative w-[50%]">
//               {!isLarge && (
//                 <IconButton onClick={handleShowFilter}>
//                   <FilterAltIcon />
//                 </IconButton>
//               )}

//               {/* Mobile Filter Drawer */}
//               <Drawer
//                 anchor="left"
//                 open={showFilter && !isLarge}
//                 onClose={() => setShowFilter(false)}
//               >
//                 <div className="w-[300px] bg-white">
//                   <FilterSection />
//                 </div>
//               </Drawer>
//             </div>

//             <FormControl size="small" sx={{ width: "200px" }}>
//               <InputLabel id="sort">Sort</InputLabel>
//               <Select
//                 labelId="sort"
//                 id="sort"
//                 value={currentSort}
//                 label="Sort"
//                 onChange={handleSortProduct}
//               >
//                 <MenuItem value="">None</MenuItem>
//                 <MenuItem value="price_low">Price : Low - High</MenuItem>
//                 <MenuItem value="price_high">Price : High - Low</MenuItem>
//               </Select>
//             </FormControl>
//           </div>

//           <Divider />

//           {products.products?.length > 0 ? (
//             <section className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-y-5 px-5 justify-center">
//               {products.products.map((item: any, index: number) => (
//                 <div
//                   key={item.id || index}
//                   className={`relative ${!item.in_stock ? "grayscale pointer-events-none" : ""}`}
//                 >
//                   <ProductCard item={item} />
//                   {!item.in_stock && (
//                     <div className="absolute top-0 left-0 w-full h-full bg-white bg-opacity-40 flex items-center justify-center rounded" />
//                   )}
//                 </div>
//               ))}
//             </section>
//           ) : (
//             <section className="items-center flex flex-col gap-5 justify-center h-[67vh] border">
//               <img
//                 className="w-80"
//                 src="https://cdn.pixabay.com/photo/2022/05/28/10/45/oops-7227010_960_720.png"
//                 alt="No product found"
//               />
//               <h1 className="font-bold text-xl text-center flex items-center gap-2">
//                 Product Not Found For
//                 <p className="text-primary-color flex gap-2 uppercase">
//                   {categoryId?.split("_").map((item) => (
//                     <span key={item}>{item}</span>
//                   ))}
//                 </p>
//               </h1>
//             </section>
//           )}

//           <div className="flex justify-center pt-10">
//             <Pagination
//               page={currentPage}
//               onChange={handlePageChange}
//               color="primary"
//               count={products?.totalPages || 1}
//               shape="rounded"
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Products;

// For modern website 
import React, { useEffect, useState } from "react";
import ProductCard from "./ProductCard/ProductCard";
import FilterSection from "./FilterSection";
import {
  Divider,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  SelectChangeEvent,
  useMediaQuery,
  useTheme,
  Drawer,
} from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { useParams, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
import { getAllProducts } from "../../../Redux Toolkit/Customer/ProductSlice";

export const images = [
  "https://manyavar.scene7.com/is/image/manyavar/I02_ma3053_06-10-2022-09-23:650x900",
  "https://manyavar.scene7.com/is/image/manyavar/I03_ma3057_06-10-2022-09-24:650x900",
  "https://manyavar.scene7.com/is/image/manyavar/I04_ma3061_06-10-2022-09-26:650x900",
  "https://manyavar.scene7.com/is/image/manyavar/I01_ma3055_06-10-2022-09-23:650x900",
];

const Products = () => {
  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
  const [showFilter, setShowFilter] = useState(false);
  const { categoryId } = useParams();
  const dispatch = useAppDispatch();
  const { products } = useAppSelector((store) => store);
  const [searchParams, setSearchParams] = useSearchParams();

  const currentSort = searchParams.get("sort") || "";
  const currentPage = Number(searchParams.get("page") || "1");

  const handleSortProduct = (event: SelectChangeEvent) => {
    const value = event.target.value as string;
    const params = new URLSearchParams(searchParams);

    if (value) {
      params.set("sort", value);
    } else {
      params.delete("sort");
    }

    params.set("page", "1");
    setSearchParams(params);
  };

  const handleShowFilter = () => {
    setShowFilter((prev) => !prev);
  };

  const handlePageChange = (
    _event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    const params = new URLSearchParams(searchParams);
    params.set("page", String(value));
    setSearchParams(params);
  };

  useEffect(() => {
    const newFilters: any = {
      size: searchParams.get("size") || "",
      color: searchParams.get("color") || "",
      pageNumber: currentPage - 1,
      minDiscount: searchParams.get("discount")
        ? Number(searchParams.get("discount"))
        : undefined,
      minPrice: searchParams.get("minPrice")
        ? Number(searchParams.get("minPrice"))
        : undefined,
      maxPrice: searchParams.get("maxPrice")
        ? Number(searchParams.get("maxPrice"))
        : undefined,
    };

    dispatch(
      getAllProducts({
        category: categoryId,
        sort: currentSort || undefined,
        ...newFilters,
      })
    );
  }, [searchParams, categoryId, currentSort, currentPage, dispatch]);

  return (
    <div className="-z-10 mt-10">
      <div>
        <h1 className="text-3xl text-center font-bold text-gray-700 pb-5 px-9 uppercase space-x-2">
          {categoryId?.split("_").map((item) => (
            <span key={item}>{item}</span>
          ))}
        </h1>
      </div>

      <div className="lg:flex">
        <section className="hidden lg:block w-[20%]">
          <FilterSection />
        </section>

        <div className="w-full lg:w-[80%] space-y-5">
          <div className="flex justify-between items-center px-9 h-[40px]">
            <div className="relative w-[50%]">
              {!isLarge && (
                <IconButton onClick={handleShowFilter}>
                  <FilterAltIcon />
                </IconButton>
              )}

              <Drawer
                anchor="left"
                open={showFilter && !isLarge}
                onClose={() => setShowFilter(false)}
              >
                <div className="w-[300px] bg-white">
                  <FilterSection />
                </div>
              </Drawer>
            </div>

            <FormControl size="small" sx={{ width: "200px" }}>
              <InputLabel id="sort">Sort</InputLabel>
              <Select
                labelId="sort"
                id="sort"
                value={currentSort}
                label="Sort"
                onChange={handleSortProduct}
              >
                <MenuItem value="">None</MenuItem>
                <MenuItem value="price_low">Price : Low - High</MenuItem>
                <MenuItem value="price_high">Price : High - Low</MenuItem>
              </Select>
            </FormControl>
          </div>

          <Divider />

          {products.products?.length > 0 ? (
            <section className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-5 px-1 sm:px-2 md:px-3 lg:px-4">
              {products.products.map((item: any, index: number) => (
                <div
                  key={item.id || index}
                  className={`relative ${
                    !item.in_stock ? "grayscale pointer-events-none" : ""
                  }`}
                >
                  <ProductCard item={item} />
                  {!item.in_stock && (
                    <div className="absolute top-0 left-0 w-full h-full bg-white/40 flex items-center justify-center rounded-[16px]" />
                  )}
                </div>
              ))}
            </section>
          ) : (
            <section className="items-center flex flex-col gap-5 justify-center h-[67vh] border">
              <img
                className="w-80"
                src="https://cdn.pixabay.com/photo/2022/05/28/10/45/oops-7227010_960_720.png"
                alt="No product found"
              />
              <h1 className="font-bold text-xl text-center flex items-center gap-2">
                Product Not Found For
                <p className="text-primary-color flex gap-2 uppercase">
                  {categoryId?.split("_").map((item) => (
                    <span key={item}>{item}</span>
                  ))}
                </p>
              </h1>
            </section>
          )}

          <div className="flex justify-center pt-10">
            <Pagination
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
              count={products?.totalPages || 1}
              shape="rounded"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;